export default {
  id: 51,
  title: 'Target #51 - Wear a Mask',
  url: 'https://cssbattle.dev/play/51',
  colors: ['#293462', '#FFF1C1', '#FE5F55'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#293462}a{position:fixed}a[a]{top:100;left:65;border:10px solid #FFF1C1;width:250;height:40;border-radius:50px}a[b]{top:110;left:125;width:150;height:90;border-radius:0 0 50px 50px;background:#FFF1C1}a[c],a[d]{background:#FE5F55;width:40}a[c]{top:120;left:145;height:10;border-radius:5px;box-shadow:0 20px #FE5F55}a[d]{top:140;left:215;height:40;border-radius:50%}</style>',
}
